import { c as _c } from "react/compiler-runtime";
import { ComponentPropsWithoutRef } from 'react';
import { styled } from '@classify/react-core-components/styles';
interface Props extends ComponentPropsWithoutRef<'section'> {
  children: React.ReactNode;
}
const StyledSection = styled('section')(({
  theme: {
    spacing
  }
}) => ({
  margin: spacing(8, 0)
}));
export default function Section(t0) {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <StyledSection {...props}>{children}</StyledSection>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}